<template>
    <div class="zonghetongji">

        <h2>综合收支统计</h2>

        <el-form inline>
            <el-form-item>
                <el-date-picker v-model="queryParams.time"
                                type="daterange"
								value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' @click="getList()">搜索</el-button>
                <!-- <el-button type='primary' @click="getList()">刷新</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tableData">
            <el-table-column label="时间" prop="createTime"></el-table-column>
            <el-table-column label="数额" prop="inOrOutMoney"></el-table-column>
            <!-- <el-table-column label="数额">
				<template slot-scope="scope">
					{{
						scope.row.paymentsType == '0' ? scope.row.money :
						scope.row.paymentsType == '1' ? scope.row.commissionMoney : ''
					}}
				</template>
			</el-table-column> -->
            <el-table-column label="加减" prop="paymentsType">
				<template slot-scope="scope">
					{{
						scope.row.paymentsType == '0' ? '收入' :
						scope.row.paymentsType == '1' ? '支出' : ''
					}}
				</template>
			</el-table-column>
            <el-table-column label="原因详情" prop="productName"/>
        </el-table>

		<el-pagination layout="prev, pager, next"
                       background
                       style="padding-top:20px;text-align:right"
                       :page-size="queryParams.pageSize"
                       :total="queryParams.total"
                       @current-change="e=>{queryParams.pageNum = e;getList()}" />

    </div>
</template>

<script>
export default {
    data () {
        return {
           queryParams:{
				pageNum:1,
				pageSize:10,
				total:0,
				time:null
		   },
		   tableData:[],
        }
    },
	mounted(){
		this.getList()
	},
    methods: {
        getList () {

			let {time} = this.queryParams
			let params = []

			if(time){
				this.queryParams['params[endTime]'] = time[1]
				this.queryParams['params[beginTime]'] = time[0]
			}else{
				delete this.queryParams['params[endTime]']
				delete this.queryParams['params[beginTime]']
			}

			params = this.$utils.getParamByJson(this.queryParams)

            this.$http.get('/stage-api/recharge/comprehensive-record?'+params).then(res=>{
				this.tableData = res.data.rows
				this.queryParams.total = res.data.total
			})

        }
    }
}
</script>

<style lang="scss" scoped>
</style>
